import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import CaptchaFamily from './CaptchaFamily';

export default class CaptchaTypeTableDto extends NamedDto {
	constructor() {
		super();
        /** @type {number} */
        this.poolSize = null
		/** @type {string} */
		this.engineName = null;
		/** @type {string} */
		this.captchaFamily = null;
	}

	/**
	 * @typedef {Object} _CaptchaTypeTableDtoProps
	 * @property {Long} poolSize 
     * @property {string} engineName
	 * @property {string} captchaFamily
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaTypeTableDtoProps} CaptchaTypeTableDtoProps
	 */
	/**
	 *
	 * @param {CaptchaTypeTableDtoProps} props
	 * @returns {CaptchaTypeTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.poolSize = props.poolSize;
        this.engineName = props.engineName;
		this.captchaFamily = props.captchaFamily;
		// this.captchaFamily = props.captchaFamily !== null ? new NamedDto().setup(props.captchaFamily) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'captchaFamily') {
            return this.captchaFamily != null ? CaptchaFamily[this.captchaFamily] : '';
		}
		return super.getAsString(key);
	}
}
